module.exports = __webpack_public_path__ + "static/img/102768.602013a0.png";